import { Theme, createStyles } from '@material-ui/core';

export const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      background: 'rgba(242, 245, 243, 0.5)', // todo: надо новый тип темы, в него добавить конфиг фонов
      flexDirection: 'column',
      userSelect: 'none',
      boxSizing: 'content-box',
      // height: 'fit-content',
    }
  });